import { createFileRoute } from '@tanstack/react-router';

import { DemandPartnersTable } from '../features/demand/partners/components/DemandPartnersTable/DemandPartnersTable';
import { demandPartnersRouteSearchSchema } from '../features/demand/partners/routeSearch';

export const Route = createFileRoute('/demand/partners/')({
  validateSearch: demandPartnersRouteSearchSchema,
  component: DemandPartnersTable,
});
